/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core';

export default function Remove({
  openDelete,
  setOpenDelete,
  loadingDelete,
  handleDelete,
}) {
  return (
    <Dialog open={openDelete} onClose={() => setOpenDelete(false)} maxWidth="xs">
      <DialogTitle>Remover Categoria</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja remover esta categoria? Essa ação não pode ser desfeita.
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={() => setOpenDelete(false)} disabled={loadingDelete}>
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="secondary"
          disabled={loadingDelete}
        >
          {loadingDelete ? <CircularProgress size={22} /> : 'Remover'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}